export default __webpack_public_path__ + "static/media/57_desktop.5a7c1672.jpg";